export const staffpayroll = [
    {
        view: "View Payslip",
        id: "8198",
        salaryFor: "Apr - 2024",
        date: "04 May 2024",
        paymentMethod: "Cash",
        netSalary: "$20,000",
        details:"View Payslip",
        key:1
    },
      {
        view: "View Payslip",
        id: "8197",
        salaryFor: "Mar - 2024",
        date: "05 Apr 2024",
        paymentMethod: "Cheque",
        netSalary: "$19,000",
        details:"View Payslip",
        key:2
    },
      {
        view: "View Payslip",
        id: "8196",
        salaryFor: "Feb - 2024",
        date: "05 Mar 2024",
        paymentMethod: "Cash",
        netSalary: "$19,500",
        details:"payslip",
        key:3
    },
      {
        view: "View Payslip",
        id: "8198",
        salaryFor: "Jan - 2024",
        date: "06 Feb 2024",
        paymentMethod: "Cash",
        netSalary: "$20,000",
        details:"payslip",
        key:4
    },
      {
        view: "View Payslip",
        id: "8194",
        salaryFor: "Dec - 2023",
        date: "03 Jan 2024",
        paymentMethod: "Cheque",
        netSalary: "$19,480",
        details:"payslip",
        key:5
    },
      {
        view: "View Payslip",
        id: "8193",
        salaryFor: "Nov - 2023",
        date: "05 Dec 2023",
        paymentMethod: "Cheque",
        netSalary: "$19,480",
        details:"payslip",
        key:6
    },
      {
        view: "View Payslip",
        id: "8192",
        salaryFor: "Oct - 2023",
        date: "03 Nov 2023",
        paymentMethod: "Cheque",
        netSalary: "$19,480",
        details:"payslip",
        key:7
    },
      {
        view: "View Payslip",
        id: "8191",
        salaryFor: "Sep - 2023",
        date: "04 Oct 2023",
        paymentMethod: "Cheque",
        netSalary: "$18,000",
        details:"payslip",
        key:8
    },
      {
        view: "View Payslip",
        id: "8190",
        salaryFor: "Aug - 2023",
        date: "06 Sep 2023",
        paymentMethod: "Cheque",
        netSalary: "$20,000",
        details:"payslip",
        key:9
    },
      {
        view: "View Payslip",
        id: "8189",
        salaryFor: "Jul - 2023",
        date: "05 Aug 2023",
        paymentMethod: "Cheque",
        netSalary: "$20,000",
        details:"payslip",
        key:10
    }
]
